<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e65oY7/tc-custom/9781595553683.jpg?1726519206012" alt="This image is the cover for the book Year of Biblical Womanhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Year of Biblical Womanhood
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Have you ever wondered what God truly expects of women? Is there really a prescription for biblical womanhood? Does the Bible's idea of womanhood have a place in modern Christianity? <i>New York Times </i>bestselling author Rachel Held Evans embarks on a year-long study of what it means to live by the standards of biblical womanhood.</b></p><p>Strong-willed and independent, Evans couldn't sew a button on a blouse before she embarked on a radical life experiment--a year of biblical womanhood. Intrigued by the traditionalist resurgence that led many of her friends to abandon their careers to assume traditional gender roles in the home, Evans decided to try it for herself, vowing to take all of the Bible's instructions for women as literally as possible for a full year.</p><p>Along the way, Evans explores the rich heritage of scriptural heroines, models of grace, and all-around women of valor that we come to know in the Bible. She consults with women who practice these ancient biblical mandates in their own lives--from an Orthodox Jewish woman who changed the way Evans reads the Bible to an Amish community that taught her the true meaning of modesty.</p><p>In <i>A Year of Biblical Womanhood,</i> Evans shares her courageous and often humorous journey of:</p>exploring what a "woman's place" is according to the Scripturesapplying the Bible's teachings to day-to-day life, sometimes to literal extremesfocusing on virtues like domesticity, obedience, beauty, submission, and gracedeveloping a "Biblical Woman's Ten Commandments" to serve as a guide for daily living<p>Join Evans as she dives deep into the lives of the women we meet in Scripture and redefines what it means to live biblically.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Held Evans
      </h2>
      
      <p class="authorDescription body article"><P><I>New York Times</I>&#160;bestselling author&#160;Rachel Held Evans (1981&ndash;2019) is known for her books and articles about faith, doubt, and life in the Bible Belt. Rachel has been featured in the&#160;<I>Washington Post</I>,&#160;<I>The Guardian</I>,&#160;<I>Christianity Today</I>,&#160;<I>Slate</I>,&#160;<I>HuffPost</I>, and the&#160;<I>CNN Belief Blog</I>, and on NPR, BBC,&#160;<I>Today</I>, and&#160;<I>The View.&#160;</I>She served on<I>&#160;</I>President Obama's Advisory Council on Faith-Based and Neighborhood Partnerships<I>&#160;</I>and kept a busy schedule speaking at churches, conferences, and universities. Rachel&rsquo;s messages continue to reverberate around the world.<BR /></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b78a838